"use client";

import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { ProfileActivityFilterTargetType } from "@/types/enums";
const TARGETS = [{
  id: ProfileActivityFilterTargetType.ALL,
  name: "All"
}, {
  id: ProfileActivityFilterTargetType.OUTGOING,
  name: "Outgoing"
}, {
  id: ProfileActivityFilterTargetType.INCOMING,
  name: "Incoming"
}];
export default function CommonFilterTargetSelect(t0) {
  const $ = _c(9);
  const {
    selected,
    onChange
  } = t0;
  const t1 = useId();
  let t2;
  if ($[0] !== t1) {
    t2 = t1.replaceAll(":", "");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const baseId = t2;
  const groupName = `filter-target-${baseId}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <legend className="tw-mb-2 tw-text-sm tw-font-medium tw-leading-6 tw-text-iron-300 sm:tw-text-md">Filter target</legend>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== groupName || $[4] !== onChange || $[5] !== selected) {
    t4 = TARGETS.map(target => {
      const inputId = `${groupName}-${target.id}`;
      return <div key={target.id} className="tw-flex tw-items-center"><input id={inputId} name={groupName} type="radio" checked={selected === target.id} onChange={() => onChange(target.id)} className="tw-form-radio tw-h-4 tw-w-4 tw-cursor-pointer tw-border tw-border-solid tw-border-iron-600 tw-bg-iron-700 tw-text-primary-400 tw-ring-offset-iron-800 focus:tw-ring-2 focus:tw-ring-primary-400" /><label htmlFor={inputId} className="tw-ml-2 tw-block tw-cursor-pointer tw-text-sm tw-font-medium tw-leading-6 tw-text-iron-300 sm:tw-text-md">{target.name}</label></div>;
    });
    $[3] = groupName;
    $[4] = onChange;
    $[5] = selected;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <fieldset className="tw-mt-6 tw-max-w-sm tw-px-4 sm:tw-px-6">{t3}<div className="tw-flex tw-items-center tw-space-x-6 tw-space-y-0">{t4}</div></fieldset>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}